import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Card,
  Typography,
  Divider,
  message
} from "antd";
import { MailOutlined, LockOutlined, BankOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import OrgService from "../../../../services/OrgService";

const { Title, Text, Link } = Typography;

const SignUpForm = () => {

  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const handleFinish = async(values) => {
    try {
      setLoading(true)
      const payload = {
        name: values?.userName,
        schoolName: values?.schoolName,
        emailAddress: values?.email,
        password: values?.confirmPassword,
      }
      const response = await OrgService.SignUp(payload);
      console.log("response is", response)
      if(response?.status === 200) {
        message.success("Your school is succesfully registered. Please login Now!");
        navigate("/auth/login");
      }
    } catch (error) {
      console.log("Error occur during Sign up", error)
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        background: "#f0f2f5",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center", 
        alignItems: "center",
        padding: "40px 20px",
      }}
    >
      <Card
        style={{
          maxWidth: 450,
          width: "100%",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <Title level={3} style={{ margin: 0 }}>
            Create Account
          </Title>
          <Text type="secondary">
            Fill in the details to get started
          </Text>
        </div>

        <Form
          form={form}
          layout="vertical"
          name="signup_form"
          onFinish={handleFinish}
          requiredMark="optional"
        >
          <Form.Item
            name="userName"
            label="User Name"
            rules={[{ required: true, message: "Please enter user name" }]}
          >
            <Input
              prefix={<BankOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="User Name"
              style={{ borderRadius: "6px" }}
              className="border-input-box"
            />
          </Form.Item>
          <Form.Item
            name="schoolName"
            label="School Name"
            rules={[{ required: true, message: "Please enter school name" }]}
          >
            <Input
              prefix={<BankOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="School Name"
              style={{ borderRadius: "6px" }}
              className="border-input-box"
            />
          </Form.Item>

          <Form.Item
            name="email"
            label="Email Address"
            rules={[
              { required: true, message: "Please enter email" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input
              prefix={<MailOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Email Address"
              style={{ borderRadius: "6px" }}
              className="border-input-box"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: "Please enter password" }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Password"
              style={{ borderRadius: "6px" }}
              className="border-input-box"
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="Confirm Password"
            dependencies={["password"]}
            rules={[
              { required: true, message: "Please confirm password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match"));
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Confirm Password"
              style={{ borderRadius: "6px" }}
              className="border-input-box"
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 12 }}>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              className="button-with-loader"
              style={{ borderRadius: "6px", fontWeight: "600", height: "45px"}}
              loading={loading}
            >
              Register Now
            </Button>
          </Form.Item>
        </Form>

        <Divider style={{ margin: "12px 0" }} />

        <div style={{ textAlign: "center" }}>
          <Text type="secondary">
            Already have an account?{" "}
            <a style={{ fontWeight: "500", color: "blue"}} onClick={() => navigate('/auth/login')}>
              Login here
            </a>
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default SignUpForm;